import React, { useState } from 'react';
import { textSendingReady, sendText, missingPlaceholders } from '../services/textMessages';

// Shows a pre-written text message that the user can edit.
// Copy text works right away. Send text stays disabled until Twilio is connected,
// then it sends the same edited text to each phone in `to`.
export default function TextMessagePanel({ defaultBody = '', to = [], onSent }) {
  const [body, setBody] = useState(defaultBody);
  const [status, setStatus] = useState('');
  const [sending, setSending] = useState(false);
  const ready = textSendingReady();
  const leftover = missingPlaceholders(body);
  const canSend = ready && to.length > 0 && leftover.length === 0 && !sending;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(body);
      setStatus('Copied. Paste it into a text message from your phone.');
    } catch (err) {
      setStatus('Copy did not work. Select the text and copy it by hand.');
    }
  };

  const send = async () => {
    setSending(true);
    setStatus('');
    const results = [];
    for (const phone of to) {
      results.push(await sendText({ to: phone, body }));
    }
    setSending(false);
    const failed = results.find((r) => !r.sent);
    if (failed) {
      setStatus(`Not sent: ${failed.reason}`);
    } else {
      setStatus('Text sent.');
      if (onSent) onSent();
    }
  };

  return (
    <div>
      <label style={{ display: 'block', fontSize: 12, color: '#7f7f7f', marginBottom: 6 }}>Text message</label>
      <textarea
        value={body}
        onChange={(e) => setBody(e.target.value)}
        style={{ width: '100%', boxSizing: 'border-box', minHeight: 140, padding: 10, border: '1px solid #d8c9a8', borderRadius: 6, fontFamily: 'inherit', fontSize: 14 }}
      />
      <div style={{ fontSize: 12, color: '#7f7f7f', marginTop: 4 }}>{body.length} characters</div>

      {leftover.length > 0 && (
        <div style={{ fontSize: 13, color: '#b00020', marginTop: 8 }}>
          Some fields are still empty and will need filling in before this can be sent: {leftover.join(', ')}
        </div>
      )}

      {!ready && (
        <div style={{ fontSize: 13, color: '#7f7f7f', marginTop: 8 }}>
          Text sending turns on once Twilio is connected. For now, copy the text and send it from your phone.
        </div>
      )}

      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 12 }}>
        <button type="button" onClick={copy} style={{ padding: '8px 14px', borderRadius: 6, border: '1px solid #8C6D1F', background: '#fff', color: '#8C6D1F', fontWeight: 600, cursor: 'pointer' }}>
          Copy text
        </button>
        <button type="button" onClick={send} disabled={!canSend} style={{ padding: '8px 14px', borderRadius: 6, border: 'none', background: canSend ? '#D4AF37' : '#e5e5e5', color: canSend ? '#000' : '#9a9a9a', fontWeight: 600, cursor: canSend ? 'pointer' : 'not-allowed' }}>
          {sending ? 'Sending...' : 'Send text'}
        </button>
      </div>
      {status && <div style={{ fontSize: 13, color: '#2e7d32', marginTop: 8 }}>{status}</div>}
    </div>
  );
}
